export enum RoleEnum {
    ADMIN = 1,
    DIRECTION_GENERALE = 2,
    DIRECTION_EDUCATION_ET_GOUVERNANCE = 3,
    //AGENT_CNEA = 4,
    COORDINATEUR_REGIONAL = 5,
    ENSEIGNANT = 6
}